"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaymentTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _faCalendarAlt = require("@fortawesome/free-solid-svg-icons/faCalendarAlt");
var _accounting = require("accounting");
var _external = require("../external");
var _Flag = require("../Flag");
var _StyledTable = require("./StyledTable.styles");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StyledPaymentTable = function StyledPaymentTable(props) {
  var paymentData = props.paymentData,
    handleTableRowClick = props.handleTableRowClick,
    testId = props.testId;
  var classes = (0, _StyledTable.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_external.Table, {
    "data-testid": testId,
    className: (0, _clsx["default"])(classes.table, props.className)
  }, /*#__PURE__*/_react["default"].createElement(_external.TableHead, null, /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Beneficiary"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Amount"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Purpose of Payment"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Payment Ref"), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, "Payment Date"))), /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, paymentData.map(function (pendingPayment, i) {
    return /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
      key: i,
      onClick: function onClick() {
        return handleTableRowClick(pendingPayment);
      },
      className: (0, _classnames["default"])(classes.clickable, classes.link)
    }, /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, /*#__PURE__*/_react["default"].createElement("span", null, pendingPayment.beneficiaryClientName)), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: "paymentAmount"
    }, /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
      code: pendingPayment.buyCurrencyCode,
      size: "sm"
    }), _accounting.accounting.format(pendingPayment.buyAmount, 2)), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, pendingPayment.purpose), /*#__PURE__*/_react["default"].createElement(_external.TableCell, null, pendingPayment.reference), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: "paymentDate"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faCalendarAlt.faCalendarAlt
    }), pendingPayment.date));
  })));
};
exports.StyledPaymentTable = StyledPaymentTable;